module.exports = __webpack_public_path__ + "img/record-vinyl.1b82e50c.svg";